import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  titles: {
    disable: 'Sigur doriți să dezactivați comenzile live?',
    enable: 'Sigur doriți să activați comenzile live?',
  },
  form: {
    delivery_app_sales_at_go_live: {
      label: 'Vânzări lunare în aplicațiile de livrare',
      description:
        'Totalul vânzărilor lunare în toate aplicațiile de livrare (Lieferando, Wolt, Uber Eats …), ca sumă întreagă. Introduceți 0 dacă restaurantul nu vinde în niciuna. După lansare, doar un administrator îl poate modifica.',
      placeholder: 'Introduceți suma lunară',
    },
    is_google_business_available: {
      label: 'Google Business disponibil',
    },
    is_smart_pricing_configured: {
      label: 'Prețuri mai mici decât Lieferando, Wolt, Uber',
    },
    is_flyers_package_sent: {
      label: 'Flyer promoțional trimis',
    },
    is_menu_fully_configured: {
      label: 'Toate produsele din meniu disponibile',
    },
    has_offers_on_competitor_platforms: {
      label: 'Restaurantul are oferte active pe Wolt, Uber, Lieferando (cu excepția livrării gratuite)?',
    },
    is_instagram_story_shared: {
      label: 'Story Instagram distribuit cu proprietarul',
    },
    is_order_system_connected_to_website: {
      label: 'Website Foodamigos conectat SAU buton comandă online adăugat pe site-ul propriu',
    },
    google_business_connected_by: {
      label: 'Cum am obținut acces la Google Business Profile?',
      options: {
        [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Managerul de vânzări a invitat google@foodamigos.io',
        [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
          'Managerul de vânzări a trimis prima solicitare de pe telefonul proprietarului',
        [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
          'Managerul de onboarding a solicitat Google Business Profile (SM nu a invitat și nu a solicitat acces)',
      },
    },
  },
  labels: {
    successful_launch:
      'Pentru a asigura o lansare de succes, vă rugăm să examinați și să rezolvați punctele deschise. Verificarea \n' +
      'acestor informații va ajuta la evitarea problemelor potențiale odată ce restaurantul este live.',
    check_errors: 'Verificați erorile pentru a asigura o lansare reușită a restaurantului.',
    checkbox_confirmation: 'Confirm că am examinat erorile și sunt de acord cu activarea acestui restaurant.',
  },
  buttons: {
    check_error: 'Verifică eroarea',
    confirm_and_activate: 'Confirmă și activează',
    cancel: 'Anulează',
    yes: 'Da',
    no: 'Nu',
  },
  errors: {
    name: {
      title: 'Niciun caracter arab, chinez etc. în numele magazinului',
      description: 'Numele magazinului online conține caractere non-engleze (latine)',
    },
    logo_url: {
      title: 'Logo',
      description: 'Logo-ul a fost încărcat în magazinul online',
    },
    pictures: {
      title: 'Imagine galerie',
      description: '≥ 1 imagine de galerie disponibilă în magazinul online',
    },
    menu_uploaded: {
      title: 'Meniu încărcat',
      description: '≥ 1 meniu disponibil',
    },
    opening_hours: {
      title: 'Program de lucru',
      description: '≥ 1 interval orar adăugat',
    },
    address: {
      title: 'Adresa restaurantului',
      description: 'Stradă, oraș, cod poștal introduse',
    },
    upsell_items: {
      title: 'Produse upsell',
      description: '≥ 3 produse upsell selectate',
    },
    master_promo_code: {
      title: 'Cod promoțional principal',
      description: 'Codul promoțional principal este disponibil',
    },
    flyers_ordered: {
      title: 'Flyere comandate',
      description: '≥ 1 pachet de flyere comandat',
    },
    test_orders: {
      title: 'Comandă de test trimisă',
      description: '≥ 1 comandă de test efectuată',
    },
    stripe_billing: {
      title: 'Cont Stripe',
      description: 'Cont Stripe conectat',
    },
    payments_configured: {
      title: 'Plăți configurate',
      description: 'Partenerul a conectat un furnizor de plăți — necesar înainte de lansare',
    },
    adyen_merchant_account: {
      title: 'Cont de comerciant Adyen',
      description:
        'Un cont de comerciant activ pentru țara acestui restaurant — necesar pentru tarifele naționale ale cardurilor',
    },
    payment_rail_covers_country: {
      title: 'Canalul de plată acoperă țara',
      description: 'Conturile de plată ale partenerului pot procesa țara acestui restaurant',
    },
    identity: {
      title: 'Identitatea restaurantului',
      description: 'Tipul și bucătăria restaurantului au fost setate',
    },
    storefront: {
      title: 'Storefront creat și domeniu conectat',
      description: 'Doar dacă restaurantul dorește să folosească site-ul nostru',
    },
    google_business: {
      title: 'Google Business',
      description: 'Google Business conectat',
    },
    billing_payment_method: {
      title: 'Metodă de plată',
      description: 'Adaugă o metodă de plată pentru ca FoodAmigos să poată factura lunar acest restaurant.',
    },
    billing_license: {
      title: 'Licență',
      description: 'Acest restaurant are nevoie de un Plan Partener înainte de a putea deveni activ.',
    },
    business_name: {
      title: 'Numele firmei / al restaurantului',
      description: 'Numele afișat în termenii de utilizare și în politica de confidențialitate a fost salvat',
    },
    payment_method: {
      title: 'Plăți cash sau online',
      description: 'Plata cash la ridicare sau livrare este activată, sau plățile online sunt verificate',
    },
    stripe_processing_fee: {
      title: 'Comision de procesare',
      description: 'Partenerul a stabilit comisionul de procesare Stripe sau a confirmat o marjă de 0%',
    },
  },
};
